import React, { createContext, useContext, useState } from 'react';
import type { StaffMember } from '@/components/BookingCalendar';

type StaffContextType = {
  selectedStaff: StaffMember | null;
  setSelectedStaff: (staff: StaffMember | null) => void;
};

const StaffContext = createContext<StaffContextType | undefined>(undefined);

export function StaffProvider({ children }: { children: React.ReactNode }) {
  const [selectedStaff, setSelectedStaff] = useState<StaffMember | null>(null);

  return (
    <StaffContext.Provider value={{ selectedStaff, setSelectedStaff }}>
      {children}
    </StaffContext.Provider>
  );
}

export function useStaff() {
  const context = useContext(StaffContext);
  if (context === undefined) {
    throw new Error('useStaff must be used within a StaffProvider');
  }
  return context;
}